import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  makeStyles,
  TableRow,
  TableCell,
  Button
} from "@material-ui/core";

import IconEstado from "../../../autorizaciones/UI/IconEstado";
import AddButtonComprobante from "../../UI/AddButtonComprobante";
import { ESTADOS_COTIZACIONES } from "../../../../utils/constants";
import { MESA_ENTRADA_PERMISOS } from '../../../../utils/permisos';
import { postComprobanteMesaEntrada } from "../../../../actions/mesaEntrada/mesaEntradaActions";
import { StepperFormExpediente } from "../StepperFormExpediente";
import moment from "moment";
import { useState } from "react";
import { ModalMostrarDatosCotizacionAceptada } from "../../../Compras/Cotizaciones/ModalMostrarDatosCotizacionAceptada";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

export const CotizacionItem = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { cotizacion } = props;
  const { cotizaciones } = useSelector((state) => state.mesaEntrada);
  const estado = useSelector((state) => state.compras.estados.find(
    estado => estado.idEstado === ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS
  ));

  const [openModalMostrarDatosCotizacionAceptada, setOpenModalMostrarDatos] = useState(false); 

  const handleSave = (formValues, handleClose) => {
    dispatch(postComprobanteMesaEntrada(formValues, handleClose));
  }

  return (
    <>
      {openModalMostrarDatosCotizacionAceptada && (
        <ModalMostrarDatosCotizacionAceptada 
            open={openModalMostrarDatosCotizacionAceptada}
            closeModalHandler={() => { setOpenModalMostrarDatos(false) }}
            cotizacion={cotizaciones.find(a => a.idSolicitud === cotizacion?.solicitud?.idSolicitud)}
            idSolicitud={cotizacion?.solicitud?.idSolicitud}
            idEstado={ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS}
            handleClose={() => setOpenModalMostrarDatos(false)}
            
        />
      )}
      <TableRow className={classes.iconEstado}>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={estado?.letra}
            backgroundColor={estado?.color}
            descripcion={estado?.descripcionEstado}
          />
        </TableCell>
        <TableCell align="center">{cotizacion?.solicitud?.idSolicitud}</TableCell>
        <TableCell align="center">{cotizaciones.length > 0 ?
            moment(cotizaciones.find(a => a.idSolicitud === cotizacion?.solicitud?.idSolicitud).fechaCotizacion).format("DD/MM/yyyy")
            : ''}
        </TableCell>
        <TableCell align="center">{cotizacion?.solicitud?.afiliado.apellido_y_nombre}</TableCell>
        <TableCell align="center">{cotizacion?.solicitud?.afiliado.carnet}</TableCell>
        <TableCell align="center">
          {cotizacion?.solicitud?.fechaProgramada ? moment(cotizacion?.solicitud?.fechaProgramada).format("DD/MM/YYYY") : ""}
        </TableCell>
        <TableCell>
          <Button
            variant='contained'
            color='primary'
            onClick={() => setOpenModalMostrarDatos(true)}
          >
              Ver Detalle
          </Button>
        </TableCell>
        <TableCell align="center">
          <AddButtonComprobante 
            title="Agregar Asociación Cotización"
            handleSave={handleSave}
            permiso={MESA_ENTRADA_PERMISOS.ALTA}
            form={StepperFormExpediente}
            cotizacion={cotizacion}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
